import axiosLimiter from '@/api/RateLimiter';

export default {  
    async getAllCollectionPages(tenant: string, params: any = {}): Promise<any> {

        const requests = [];
        let currentPage = 1;
        let totalPages = null;
        let nextPageLink = null;
    
        while (totalPages === null || currentPage < totalPages+1) {
            let requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenant + '/connectors?';

            if('name' in params && params.name && params.name.length > 0) {
                requestURL = requestURL + '&name=' + encodeURIComponent(params.name);
            }
            if('createdFrom' in params && params.createdFrom && params.createdFrom.length > 0) {
                requestURL = requestURL + '&createdFrom=' + encodeURIComponent(params.createdFrom);
            }
            if('createdUntil' in params && params.createdUntil && params.createdUntil.length > 0) {
                requestURL = requestURL + '&createdUntil=' + encodeURIComponent(params.createdUntil);
            }
            if('tag' in params && params.tag && params.tag.length > 0) {
                requestURL = requestURL + '&tagId=' + encodeURIComponent(params.tag);
            }
            if('tagIds' in params && params.tagIds && params.tagIds.length > 0) {
                requestURL = requestURL + '&tagIds=' + encodeURIComponent(params.tagIds.join(','));
            }
            if('propertyId' in params && params.propertyId && params.propertyId.length > 0) {
                requestURL = requestURL + '&propertyId=' + encodeURIComponent(params.propertyId);
            }

            if(nextPageLink) {
                requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + nextPageLink;
            }
            const response: Promise<any> = axiosLimiter.get(requestURL);

            if (totalPages === null || currentPage < totalPages+1) {
                const results: any = await response;
                totalPages = parseInt(results.data.meta.page.totalPages);
                nextPageLink = results.data.links.next;
            }
            requests.push(response);
            currentPage++;
        }
    
        return Promise.all(requests);
    },
    getSingle(tenant: string, connectorUUID: string): Promise<any> {
        return axiosLimiter.get(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenant + '/connectors/' + connectorUUID);
    },
    createConnector(tenantUUID: string, name: string, inputType: string, propertyId: string): Promise<any> {
        const body = {
            data: {
                type: "connectors",
                attributes: {
                    name: name,
                    inputType: inputType
                },
                relationships: {
                    property: {
                        data: {
                            type: "properties",
                            id: propertyId
                        }
                    }
                }
            }
        } as any;

        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors', JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },
    deleteConnector(tenantUUID: string, connectorUUID: string): Promise<any> {
        return axiosLimiter.delete(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID);
    },
    updateConnector(tenantUUID: string, connectorUUID: string, name = "", inputType = "", propertyId = ""): Promise<any> {

        const body = {
            data: {
                type: "connectors",
                id: connectorUUID,
                attributes: {
                },
                relationships: {
                }
            }
        } as any;

        if(name.length > 0) {
            body.data.attributes.name = name;
        }
        if(inputType.length > 0) {
            body.data.attributes.inputType = inputType;
        }
        if(propertyId.length > 0) {
            body.data.relationships.property = {
                data: { type: "properties", id: propertyId }
            };
        }

        return axiosLimiter.patch(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID, JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },
    getAssociatedProperty(tenantUUID: string, connectorUUID: string): Promise<any> {
        return axiosLimiter.get(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID + '/property');
    },
    getAssociatedDevices(tenantUUID: string, connectorUUID: string): Promise<any> {
        return axiosLimiter.get(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID + '/devices');
    },
    getAssociatedTags(tenantUUID: string, connectorUUID: string): Promise<any> {
        return axiosLimiter.get(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID + '/tags');
    },    
    addTags(tenantUUID: string, connectorUUID: string, tags: any[]): Promise<any> {
        const body = {
            data: []
        } as any;

        for(const tag of tags) {
            body.data.push({
                type: "tags",
                id: tag.uuid
            });
        }
        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID + '/tags', JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },
    removeTags(tenantUUID: string, connectorUUID: string, tags: any[]): Promise<any> {
        const body = {
            data: []
        } as any;

        for(const tag of tags) {
            body.data.push({
                type: "tags",
                id: tag.uuid
            });
        }
        return axiosLimiter.delete(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID +  '/connectors/' + connectorUUID + '/tags', { headers: {'Content-Type': 'application/vnd.api+json'}, data: JSON.stringify(body)});
    },
    generateToken(tenantUUID: string, connectorUUID: string): Promise<any> {               
        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID + '/generateToken', '', { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },
    getAssociatedAlerts(tenantUUID: string, connectorUUID: string): Promise<any> {
        return axiosLimiter.get(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID + '/alerts');
    },
    addAlert(tenantUUID: string, connectorUUID: string, recipients: string[], maxAge: number, paused?: boolean): Promise<any> {
        const body = {
            "data": {
                "type": "alerts",
                "attributes": {
                    "maxAge": maxAge,
                    "recipients": recipients
                }
            }
        } as any;

        if(paused !== undefined) {
            body.data.attributes.paused = paused;
        }

        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID + '/alerts', JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },
    updateAlert(tenantUUID: string, connectorUUID: string, alertUUID: string, recipients?: string[], maxAge?: number, paused?: boolean): Promise<any> {
        const body = {
            "data": {
                "id": alertUUID,
                "type": "alerts",
                "attributes": {
                }
            }
        } as any;

        if(recipients && recipients.length > 0) {
            body.data.attributes.recipients = recipients;
        }
        if(maxAge) {
            body.data.attributes.maxAge = maxAge;
        }
        if(paused !== undefined) {
            body.data.attributes.paused = paused;
        }

        return axiosLimiter.patch(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID + '/alerts/' + alertUUID, JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },
    removeAlert(tenantUUID: string, connectorUUID: string, alertUUID: string): Promise<any> {
        return axiosLimiter.delete(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID + '/alerts/' + alertUUID);
    },
    getNotes(tenantUUID: string, connectorUUID: string): Promise<any> {
        return axiosLimiter.get(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID + '/notes?page[size]=1000');
    },
    createNote(tenantUUID: string, connectorUUID: string, body: string, visibility: string): Promise<any> {
        const payload = {
            data: {
                type: "notes",
                attributes: { body, visibility }
            }
        };
        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID + '/notes', JSON.stringify(payload), { headers: { 'Content-Type': 'application/vnd.api+json' } });
    },
    updateNote(tenantUUID: string, connectorUUID: string, noteUUID: string, body: string): Promise<any> {
        const payload = {
            data: {
                type: "notes",
                id: noteUUID,
                attributes: { body }
            }
        };
        return axiosLimiter.patch(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID + '/notes/' + noteUUID, JSON.stringify(payload), { headers: { 'Content-Type': 'application/vnd.api+json' } });
    },
    deleteNote(tenantUUID: string, connectorUUID: string, noteUUID: string): Promise<any> {
        return axiosLimiter.delete(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/connectors/' + connectorUUID + '/notes/' + noteUUID);
    },
}
  